import { Section } from 'components/Rsuite/Section';
import { useEffect, useCallback, useState } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { RsButton } from 'components/Rsuite/Button';
import { useFormik } from 'formik';
import { Form } from 'rsuite';
import { RsInput } from 'components/Rsuite/Input';
// import { useCoreContext } from 'contexts/coreContext'; // 暫時用不到
import BidPrice from './Shop/BidPrice'; // 出價上限
import BrandSelection from './Shop/BrandSelection';
import BudgetRadios from './Shop/BudgetRadios';
import FutureDate from './Shop/FutureDate';
import { LoadingIndicator } from 'components/LoadingIndicator';
import useBaseForm from 'containers/RtbCampaigns/RtbCampaignSinglePage/Hooks/useBaseForm';
import useShopForm from '../Hooks/useShopForm';
import useShopFormValidation from '../Hooks/useShopFormValidation';
import { ShopCreativeManager } from 'components/Rsuite/CreativeManager';
import { useCampaignStore } from 'store/campaignStore';
import {
  DefaultRtbCampaignManager,
  RtbCampaignManager,
} from 'core/rtbCampaign/RtbCampaignManager';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import useCreativeStore from 'store/creativeStore';
import {
  CreativeManager,
  DefaultCreativeManager,
} from 'core/creative/CreativeManager';
import {
  BindingManager,
  DefaultBindingManager,
} from 'core/binding/BindingManager';
import { L1ObjectChannel } from 'core/l1Object/L1Object';
import TreeSelect from '../../../../components/TreeSelect/TreeSelect';
import { findNode } from 'components/TreeSelect/treeHelper';
import {
  RestfulCampaignWebService,
  ShopCategoryNode,
} from 'ws/ShopCategoryWebService';
import InfoOutlineIcon from '@rsuite/icons/InfoOutline';
import { a } from 'react-spring';
interface ShopFormProps {
  defaultForm: any;
}

const campaignManager: RtbCampaignManager = new DefaultRtbCampaignManager();
const creativeManager: CreativeManager = new DefaultCreativeManager();
const bindingManager: BindingManager = new DefaultBindingManager();

const ShopForm: React.FC<ShopFormProps> = ({ defaultForm }) => {
  const [selectedCategories, setSelectedCategories] = useState<
    ShopCategoryNode[]
  >([]);
  const [treeData, setTreeData] = useState<ShopCategoryNode[]>([]);
  const [loadingCategories, setLoadingCategories] = useState<boolean>(false);
  const history = useHistory();
  const { handleLoading } = useCampaignStore();
  const { creative } = useCreativeStore();
  const { values, setFieldValue, handleSubmit } = useFormik({
    initialValues: { ...defaultForm },

    onSubmit: async (values) => {
      const filteredCategories = values.selectedCategories?.map((category) => ({
        value: category.value,
        label: category.label,
      }));
      values.basic.category = filteredCategories ?? [];

      // use validationSchema , API 確定時處理, 要注意 basic 之外要傳的 props
      // validationSchema
      handleLoading(true);
      try {
        switch (actionType) {
          case 'edit':
            handleUpdateCampaign();
            break;
          case 'create':
            handlereateCampaign();
            break;
          case 'copy':
            handlereateCampaign();
            break;
          default:
            break;
        }
      } catch (error) {
        console.error('Failed to create campaign:', error);
        handleLoading(false);
      }
    },
  });

  const handleCreateCreative = async (campaignId) => {
    try {
      const creativeJson = [
        {
          creative: {
            name: creative.name,
            bannerUrl: creative.bannerUrl,
            creativeType: 14,
            advertiserId: order.advertiserId,
            categoryCode: creative.bannerExtra.categoryCode,
            webBrandNo: creative.bannerExtra.webBrandNo,
            tenmaxCategory: 'e_commerce',
            typeProperties: {
              primaryProduct: JSON.stringify(creative.product),
            },
          },
        },
      ];
      if (creative.creativeId) {
        return handleBindCreative(campaignId, { creative });
      }
      const data = await creativeManager.createCreativesByJson(creativeJson);
      if (data) {
        handleBindCreative(campaignId, data.data[0]);
      }
    } catch (error) {
      console.error(error);
      handleLoading(false);
    }
  };
  const handleBindCreative = async (campaignId: string, data: any) => {
    try {
      const bind = await bindingManager.createShopBinding(L1ObjectChannel.RTB, [
        {
          l2ChannelIds: [campaignId],
          active: true,
          creativeIds: [data.creative.creativeId.toString()],
        },
      ]);
      toast.success('成功');
      history.push(`/orders/${order?.orderNumber}`);
    } catch (error) {
      console.error(error);
      handleLoading(false);
    } finally {
      handleLoading(false);
    }
  };
  const handlereateCampaign = async () => {
    try {
      const createCampaign = await campaignManager.createCampaign(
        values,
        order.l1Objects[0]?.l1ObjectId,
      );
      if (createCampaign) {
        handleCreateCreative(createCampaign);
      }
    } catch (error) {
      console.error('Failed to update campaign:', error);
      handleLoading(false);
    }
  };
  const handleUpdateCampaign = async () => {
    try {
      const updateCampaign = await campaignManager.updateCampaign(
        values,
        order.l1Objects[0]?.l1ObjectId,
      );
      toast.success('成功');

      history.push(`/orders/${order?.orderNumber}`);
    } catch (error) {
      console.error('Failed to update campaign:', error);
      handleLoading(false);
    } finally {
      handleLoading(false);
    }
  };

  const restfulCampaignWebService = new RestfulCampaignWebService();

  const fetchCategories = useCallback(async (webBrandNo: string) => {
    try {
      const categories =
        await restfulCampaignWebService.getShopProductCategories(webBrandNo);
      setTreeData(categories);
    } catch (error) {
      console.error('Failed to fetch categories:', error);
    } finally {
      setLoadingCategories(false);
    }
  }, []);
  // 當選擇品牌時載入分類資料
  useEffect(() => {
    if (values.basic?.webBrandNo) {
      fetchCategories(values.basic.webBrandNo);
    }
  }, [values.basic?.webBrandNo, fetchCategories]);

  // 初始化載入分類資料
  useEffect(() => {
    if (values.basic?.category?.length) {
      const restored = values.basic.category
        .map((selectedCategory) => {
          const found = findNode(treeData, selectedCategory.value)?.node;
          // if (!found) return null;

          return {
            id: found?.id || selectedCategory.value,
            value: found?.value || selectedCategory.value,
            label: found?.label || selectedCategory.label,
          };
        })
        .filter(Boolean);
      setSelectedCategories(restored);
      setFieldValue('selectedCategories', restored);
    }
  }, [treeData, values.basic?.category]);

  const handleCategoryChange = (allSelectedIds: string[]) => {
    const leafNodes = allSelectedIds
      .map((id) => findNode(treeData, id).node)
      .filter(
        (node) => node && (!node.children || node.children.length === 0),
      ) as ShopCategoryNode[];

    const selectedLeafNodes = leafNodes.map((item) => ({
      id: item.id,
      value: item.value,
      label: item.label,
      count: item.count,
    }));

    setFieldValue('selectedCategories', selectedLeafNodes);
    setSelectedCategories(selectedLeafNodes);
    handleValidation();
  };

  const resetCategoryState = () => {
    setTreeData([]);
    setSelectedCategories([]);
    setFieldValue('selectedCategories', []);
  };

  const handleBrandChange = (webBrandNo: string) => {
    resetCategoryState();
    handleChangeBrand(webBrandNo);
  };

  const {
    campaignMinDate,
    handleCampaignNameChange, // 切換品牌
    handleBack, // 回到 select-adType
  } = useBaseForm({
    values,
    setFieldValue,
  });

  const {
    order,
    brandOptions,
    loading,
    actionType,
    diffDays,
    suggestCpc,
    suggestDailyTargetBudget,
    handleChangeBrand,
    handleDateRangeChange,
    handleChangeStartDate,
    handleChangeEndDate,
    handleBudgetTypeChange,
    handleBudgetChange,
    handleChangeBidPrice,
  } = useShopForm({
    defaultForm,
    values,
    setFieldValue,
  });

  const { errors, handleValidation } = useShopFormValidation({
    defaultForm,
    values,
  });

  useEffect(() => {
    handleValidation();
  }, [values]);

  return (
    <>
      {loading && <LoadingIndicator />}
      <Section title='廣告基本設定與出價' className={'min-h-[500px]'}>
        <Form layout='horizontal' className='w-[1260px]'>
          <Form.Group className='!mb-[36px]'>
            <Form.ControlLabel>活動名稱</Form.ControlLabel>
            <RsInput
              value={values.basic?.name}
              onChange={handleCampaignNameChange}
              className='!w-80'
              // 這邊這樣寫不好, 根本解決方法是在 initialvalues 定義完整型別
              errorMessage={(errors.basic as { name?: string })?.name}
            />
          </Form.Group>

          <Form.Group className='!mb-[36px]'>
            <Form.ControlLabel>品牌選擇</Form.ControlLabel>
            <div className='flex w-[350px] flex-wrap items-center'>
              <BrandSelection
                values={values}
                brandOptions={brandOptions}
                onChange={handleBrandChange}
                errorMessage={errors?.basic?.webBrandNo as string}
              />
              <Form.HelpText className='!ml-0 mt-1 !text-[#808080]'>
                此清單僅列出符合黃金置頂搜尋廣告資格的品牌
              </Form.HelpText>
            </div>
          </Form.Group>

          <Form.Group className='!mb-[36px]'>
            <Form.ControlLabel>商品分類</Form.ControlLabel>
            <div className='inline-block'>
              {actionType === 'edit' ? (
                <div className='rs-input !flex !w-[380px] flex-1 cursor-not-allowed flex-wrap items-center gap-2 !bg-[#f7f7fa] hover:!border-gray-100'>
                  {selectedCategories.length > 0 ? (
                    selectedCategories.map((item) => (
                      <div
                        key={item.id}
                        className='flex items-center justify-center rounded-sm bg-gray-200 p-1 text-xs text-[#717273]'
                      >
                        {item.label}
                      </div>
                    ))
                  ) : (
                    <div className='text-gray-500'>全部</div>
                  )}
                </div>
              ) : (
                <TreeSelect
                  treeData={treeData}
                  value={selectedCategories.map((item) => item.id)}
                  onChange={handleCategoryChange}
                  placeholder={
                    loadingCategories ? '載入中...' : '請選擇 (未設定則全選)'
                  }
                  loading={loadingCategories}
                  allowClear
                  disabled={loadingCategories || !values.basic?.webBrandNo}
                  autoCheckChildren={false}
                  showSelectAll={false}
                  errorMessage={errors?.selectedCategories as string}
                />
              )}
              <Form.HelpText className='mt-1 !text-[#808080]'>
                列表僅顯示該品牌下符合資格之商品分類，如未設定系統將直接帶入該品牌全部商品
              </Form.HelpText>
            </div>
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>廣告期間</Form.ControlLabel>
            <FutureDate
              errors={errors}
              values={values}
              minDate={moment(campaignMinDate).format('YYYY-MM-DD HH:mm:ss')}
              maxDate={moment(order.endDate)
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss')}
              diffDays={diffDays}
              actionType={actionType}
              onChange={handleDateRangeChange}
              onChangeStartDate={handleChangeStartDate}
              onChangeEndDate={handleChangeEndDate}
            />
          </Form.Group>

          <Form.Group controlId='data-range-radio'>
            <Form.ControlLabel>廣告預算</Form.ControlLabel>
            <BudgetRadios
              diffDays={diffDays}
              suggestDailyTargetBudget={suggestDailyTargetBudget}
              values={values}
              errors={errors}
              onBudgetTypeChange={handleBudgetTypeChange}
              onBudgetChange={handleBudgetChange}
            />
          </Form.Group>

          <Form.Group className='w-[35rem]'>
            <Form.ControlLabel>出價上限</Form.ControlLabel>
            <BidPrice
              currency={order.currency}
              values={values}
              suggestCpc={suggestCpc}
              errors={errors}
              onBidPriceChange={handleChangeBidPrice}
            />
          </Form.Group>
        </Form>
      </Section>
      <Section title='素材設定'>
        <ShopCreativeManager
          campaignId={defaultForm.basic.id}
          camPaign={values}
        />
      </Section>
      <div className='my-8 ml-8 flex items-center gap-4'>
        <RsButton
          appearance='primary'
          onClick={handleSubmit}
          disabled={
            (actionType !== 'edit' &&
              (!_.isEmpty(errors) || _.isEmpty(creative))) ||
            !_.isEmpty(errors)
          }
        >
          完成
        </RsButton>
        <RsButton appearance='ghost' onClick={handleBack}>
          取消
        </RsButton>
      </div>
    </>
  );
};

export default ShopForm;
